import clsx from 'clsx';
import style from './style.module.scss';

const Textarea = ({ id, name, required, label, placeholder, errors }) => {
    const err = errors.filter((el) => el.field === name);

    return (
        <div className={style.block}>
            <label htmlFor={id} className={clsx(style.label, required && style.required)}>
                {label}
            </label>
            <textarea placeholder={placeholder} name={name} id={id} required={required} />

            {err && err.length ? <div className={style.error}>{err[0].message}</div> : <></>}
        </div>
    );
};

export default Textarea;
